import { createContext, Dispatch, useReducer } from 'react';
import { DocumentItemType } from '../../Components/Utilities/DocumentsView';
import { RepaymentScheduleItemType } from '../../Components/Utilities/RepaymentsSchedule';
import { SignDetails } from '../../Helpers/Parsers/SignParser';
import { InstantLoanPaymentDate } from '../../Helpers/Requests/types';

type RequestsStateType = {
  loanDetails?: number;
  repayments?: number;
  totalAmountOfPayments?: number;
  countdownContractExpireDate?: Date;
  changeableLastDate?: boolean;
  repaymentScheduleItems?: RepaymentScheduleItemType[];
  loanId?: number;
  token?: string;
  loanContract?: DocumentItemType;
  padContract?: DocumentItemType;
  firstName?: string;
  lastName?: string;
  isReloan?: boolean;
  nbLoans?: number;
  referralAmbassadorName?: string;
  provinceId?: number;
  signDetails?: SignDetails;
  paymentDate?: InstantLoanPaymentDate;
  applicationId?: number;
  contactId?: number;
};

type RequestsActionType =
  | {
    type: 'checkedPayment',
    payload: {
      index: number;
      value: boolean;
    }
  }
  | {
      type: 'setData';
      payload?: {
        loanDetails?: number;
        repayments?: number;
        totalAmountOfPayments?: number;
        countdownContractExpireDate?: Date;
        repaymentScheduleItems?: RepaymentScheduleItemType[];
        changeableLastDate?: boolean;
        loanId?: number;
        paymentDate?: InstantLoanPaymentDate
      };
    }
  | {
    type: 'setPaymentDate'
    payload?: {
      paymentDate?: InstantLoanPaymentDate
    }
  }
  | {
      type: 'setLoanContract';
      payload?: {
        file?: DocumentItemType;
      };
    }
  | {
      type: 'setPADContract';
      payload?: {
        file?: DocumentItemType;
      };
    }
  | {
      type: 'setToken';
      payload?: {
        token?: string;
      };
    }
  | {
    type: 'setSignData',
    payload?: SignDetails
  }
  | {
      type: 'setUser';
      payload?: {
        firstName?: string;
        lastName?: string;
        isReloan?: boolean;
        nbLoans?: number;
        referralAmbassadorName?: string;
        provinceId?: number;
        applicationId?:number;
        contactId?: number
      };
    };

const dashboardsReducer = (state: RequestsStateType, action: RequestsActionType) => {
  switch (action.type) {
    case 'setData':
      return {
        ...state,
        loanDetails: action.payload?.loanDetails,
        repayments: action.payload?.repayments,
        totalAmountOfPayments: action.payload?.totalAmountOfPayments,
        countdownContractExpireDate: action.payload?.countdownContractExpireDate,
        repaymentScheduleItems: action.payload?.repaymentScheduleItems,
        changeableLastDate: action.payload?.changeableLastDate,
        loanId: action.payload?.loanId,
        paymentDate: action.payload?.paymentDate
      };
    case 'setLoanContract':
      return { ...state, loanContract: action.payload?.file };
    case 'setPADContract':
      return { ...state, padContract: action.payload?.file };
    case 'setToken':
      return { ...state, token: action?.payload?.token };
    case 'checkedPayment': {
      const repaymentScheduleItems = [...state.repaymentScheduleItems ?? []]
      repaymentScheduleItems[action.payload.index].checked = action.payload.value
      return {...state, repaymentScheduleItems: repaymentScheduleItems}
    }
    case 'setSignData': {
      return {...state, signDetails: action.payload}
    }
    case 'setPaymentDate': {
      return {...state, paymentDate: action.payload?.paymentDate}
    }
    case 'setUser':
      return {
        ...state,
        firstName: action?.payload?.firstName,
        lastName: action?.payload?.lastName,
        isReloan: action?.payload?.isReloan,
        nbLoans: action?.payload?.nbLoans,
        referralAmbassadorName: action?.payload?.referralAmbassadorName,
        provinceId: action?.payload?.provinceId,
        applicationId: action?.payload?.applicationId,
        contactId: action?.payload?.contactId
      };
    default:
      return state;
  }
};

export const useDashboardsReducer = () => useReducer(dashboardsReducer, {}, () => ({}));

export const DashboardsContext = createContext<{
  state: RequestsStateType;
  dispatch: Dispatch<RequestsActionType>;
}>({
  state: {},
  dispatch: _action => {},
});
